import { LuCopy } from "react-icons/lu";
import { toast, ToastContentProps } from "react-toastify";

export const ErrorToast = (
  props: ToastContentProps<{ name: string; message: string }>
) => {
  const { data } = props;

  return (
    <div className="bg-red/10 text-red/75 border-red/15 flex w-full gap-2 rounded-xl border px-3.5 py-2.5">
      <div className="flex grow flex-col">
        <h3 className="text-sm font-semibold">{data.name}</h3>
        <p className="text-sm">{data.message}</p>
      </div>
      <div className="flex items-center justify-center">
        <button
          className="cursor-pointer outline-hidden"
          onClick={async () => {
            try {
              await window.navigator.clipboard.writeText(data.message);
            } catch (error) {
              console.error(error);
            }
          }}
        >
          <LuCopy className="size-5" />
        </button>
      </div>
    </div>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const notifyError = (name: string, message: string) => {
  return toast.error(ErrorToast, {
    data: { name, message },
  });
};
